import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import NewsInfo from "./pages/newsinfo/NewsInfo";
import Video from "./pages/video/Video";
import NewsInfo1 from "./pages/newsinfo/NewsInfo1";
import About from "./pages/about/About";
import Politics from "./pages/politics/Politics";
import State from "./pages/state/State";
import Country from "./pages/country/Country";
import Crime from "./pages/crime/Crime";
import World from "./pages/world/World";
import Breaking from "./pages/breaking/Breaking";
import Business from "./pages/business/Business";
import Sports from "./pages/sports/Sports";
import Education from "./pages/education/Education";
import NewsDetail from "./pages/newsDetail/NewsDetail";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />           {/* hold*/}
            <Route path="/about-us" element={<About />} />                  {/* hold*/}
            <Route path="/news-info" element={<NewsInfo />} />
            <Route path="/news_info" element={<NewsInfo1 />} />
            <Route path="/video" element={<Video />} />
            <Route path="/politics" element={<Politics />} />
            <Route path="/state" element={<State />} />
            <Route path="/country" element={<Country />} />
            <Route path="/crime" element={<Crime />} />
            <Route path="/world" element={<World />} />
            <Route path="/breaking-news" element={<Breaking />} />
            <Route path="/business" element={<Business />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/education" element={<Education />} />



            <Route path="/" element={<Breaking />} />
            <Route path="/breaking" element={<Breaking />} />
            <Route path="/news/:id" element={<NewsDetail />} />



          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
